import { render, staticRenderFns } from "./RbuSectionFluctuationContractPercentage.vue?vue&type=template&id=6df95248"
import script from "./RbuSectionFluctuationContractPercentage.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuationContractPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports